// extracted by mini-css-extract-plugin
module.exports = {"widgetValue":"Analysis_widgetValue__1Lipc","widgetLabel":"Analysis_widgetLabel__3ACrQ","circle":"Analysis_circle__2J3Mh","analysisStats":"Analysis_analysisStats__3Qpk6"};